import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useInput, useNotification} from '~/hooks';
import {Col, UiImage, UiText, UiQuestionnaireLayout, UiBox, AppDatePicker} from '~/components/elements';
import MenstrualHealth from '~/assets/images/icons/menstrual-health.png';
import {RootState} from '~/redux/root-reducer';
import {EMERGENCY_CONTRACEPTION_KEYS} from '~/constants/medical-questionnaires';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import moment from 'moment';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire8Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const [startDate, setStartDate] = useState(new Date());

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[EMERGENCY_CONTRACEPTION_KEYS.LAST_PERIOD_AT]?.data,
  );

  const {inputs, setInputs} = useInput({selectedOption: currentAnswer?.selectedOption || new Date().toISOString()});

  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === EMERGENCY_CONTRACEPTION_KEYS.LAST_PERIOD_AT);

  const onChange = (dates: Date) => {
    setInputs({selectedOption: dates.toISOString()});
  };

  const onClickSubmit = async () => {
    dispatch(
      setQuestionnaireAnswer({
        key: EMERGENCY_CONTRACEPTION_KEYS.LAST_PERIOD_AT,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    dispatch(setNextQuestionnaire({value: EMERGENCY_CONTRACEPTION_KEYS.HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH}));
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      disableNext={!inputs.selectedOption}
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
    >
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.medium} />
        <UiText fontSize="xl" fontWeight="bold" mt={spacing.large}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiBox mt={spacing.large}>
          <AppDatePicker maxDate={moment().toDate()} selected={inputs.selectedOption} onChange={onChange} inline />
        </UiBox>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire8Screen;
